<template>
  <div class="box">
    <div class="main">
      <h3>注册成功!</h3>
      <!-- <p>登录习讯云校企合作平台  https://qxiaoyun.com</p> -->
      <p>请通知学生提交实习申请</p>
    </div>
    <div class="member">
      <div class="t1">习讯-企校云平台</div>
      <div class="t2" style="color: #4090E6;">电脑登录网址：qxiaoyun.com</div>
      <div class="t2">校企合作/技能人才招聘一站式服务平台</div>
      <div class="t3">全国1000+学校&nbsp;&nbsp;&nbsp;&nbsp;100万+学生</div>
      <div class="t4">大数据精准匹配，开启您的校企合作之路</div>
      <div class="wechat">
        <div>
          <div>关注企校云服务号及时查看学生投递情况，发布或更新岗位信息</div>
          <img src="https://www.xixunyun.com/webapp-new/img/wx-xixun.jpg" />
        </div>
        <!-- <div style="margin-top: 20px;">
          <div>填加客服微信，反馈使用问题，及合作事宜</div>
          <img src="https://www.xixunyun.com/webapp-new/img/wx-person.jpg" />
        </div> -->
      </div>
      <el-button v-if="pc" type="primary" @click="pushRouter('/')">立即体验</el-button>
      <!-- <div class="ope">
        <el-button 
          v-if="schoolNeedFee && payStatus"
          type="primary" 
          @click="pushRouter('/enterprise-pay-h5', {...$route.query})"
          >企业认证</el-button>
        <el-button v-if="pc" type="primary" @click="pushRouter('/')">立即体验</el-button>
        <div class="ex" v-if="schoolNeedFee && payStatus">(企业完成平台认证，可享更多功能服务！)</div>
      </div> -->
    </div>

    <!-- <div class="other" v-if="schoolNeedFee && payStatus">
      <div style="margin: 10px 0; text-align: center;">企业完成平台认证，可享更多功能服务！</div>
      <div class="bottom">
        <el-button
          type="primary"
          @click="pushRouter('/enterprise-pay-h5', {...$route.query})"
        >如需更多服务，请点此认证后登陆平台查看！</el-button>
      </div>
    </div> -->
  </div>
</template>

<script>
import baseUrl from "@/api/baseUrl.js";
import axios from "axios";
import qs from "qs";
import formatter from "@/assets/js/mixins/formatter";
import time from "@/assets/js/time.js";
import {isPC} from '@/assets/js/common'

export default {
  mixins: [formatter],
  data() {
    return {
      payStatus: true,
      schoolNeedFee: false,
      pc: false,
    };
  },
  mounted() {
    // this.getPayState();

    isPC() ? this.pc = true : ''

    //  需要企业付费的学校
    // let schoolsId = ["1593", "46"];
    // let currentSchoolId = this.$route.query.schoolId;
    // if (schoolsId.indexOf(currentSchoolId) != -1) {
    //   this.schoolNeedFee = true;
    // }
  },
  methods: {
    async getPayState() {
      let res = await this.$api.info.get();
      let info = res.data[0];
      // 判断是否付费
      if (info.pay_status === "paid") {
        this.payStatus = false;
        // let nowTimestamp = new Date().getTime();
        // let dueTimestamp = time.getTimestamp(info.due_date);
        // // 判断是否到期
        // if (dueTimestamp > nowTimestamp) {
        //   this.payStatus = false;
        // }
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../assets/css/base.scss";

.box {
  margin: 0 auto;
  width: 100%;
  background: url("../../assets/img/bg.png") no-repeat;
  background-size: 100%;
  min-height: 650px;
  padding-bottom: 100px;
  .main {
    text-align: center;
    padding-top: 30px;
    color: #fff;

    h3 {
      font-weight: bold;
      font-size: vw(40);
    }

    p {
      margin-top: vw(38);
      line-height: 30px;
      padding: 0 15px;
      font-size: vw(36);
    }
  }
  .member {
    width: 95vw;
    box-sizing: border-box;
    margin: vw(20) auto 0;
    padding: vw(80) 0 vw(50) 0;
    border: 1px solid #ddd;
    border-radius: vw(20);
    background: #fff;
    text-align: center;
    .introduce {
      padding: 10px 0;

      .title {
        font-size: vw(30);
        font-weight: bold;
        margin-bottom: vw(10);
      }

      div {
        display: flex;
        align-items: center;
        margin-right: vw(10);
        font-size: vw(24);
        line-height: 1.8;
      }

      div span {
        display: inline-block;
        width: vw(7);
        height: vw(7);
        border-radius: 50%;
        background: #4b7ff7;
        margin-right: vw(10);
      }
    }
    .t1 {
      font-size: vw(40);
      font-weight: bold;
    }
    .t2 {
      margin-top: 10px;
      font-size: vw(30);
    }
    .t3 {
      margin-top: 60px;
      color: $blue;
      font-size: vw(36);
      font-weight: bold;
    }
    .t4 {
      margin-top: 10px;
      color: $blue;
      font-size: vw(32);
    }
    .wechat {
      margin-top: 50px;

      img {
        width: 150px;
        height: 150px;
      }
    }
    .ope {
      margin-top: 20px;
      .el-button {
        width: 150px;
      }
      .ex {
        margin-top: 20px;
        color: red;
      }
    }
  }

  .bottom {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100vw;
    height: 60px;
    text-align: center;
  }
}

@media screen and (min-width: 500px) {
  .box {
    background-size: 100% 500px;
    .main {
      h3 {
        font-size: 30px;
      }

      p {
        font-size: 24px;
        margin-top: 20px;
      }
    }
    .member {
      width: 500px;
      padding: 20px;

      .t1,
      .t2,
      .t3,
      .t4 {
        font-size: 20px;
      }
    }
  }
}
</style>